var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { attrs: { id: "list-tasks" } }, [
    _c("li", [
      _c(
        "div",
        {
          staticClass: "fv ct",
          staticStyle: {
            width: "210px",
            height: "120px",
            "border-width": "1px",
            border: "1px solid #dddddd",
            background: "#ffffff",
            "box-shadow": "2px 2px 4px #dddddd",
            "-webkit-box-shadow": "2px 2px 4px #dddddd",
            "-moz-box-shadow": "2px 2px 4px #dddddd",
            "border-radius": "10px"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "fh cc",
              staticStyle: {
                "text-align": "center",
                width: "90%",
                height: "25%",
                "font-size": "12px",
                color: "#5c666f",
                "font-weight": "600"
              }
            },
            [
              _vm._v(
                " \n                " +
                  _vm._s(_vm.item.Nombre) +
                  " \n            "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "fh cc",
              staticStyle: { width: "100%", height: "75%" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "fh cc",
                  staticStyle: { width: "40%", height: "100%" }
                },
                [
                  _c("img", {
                    staticStyle: { width: "80%" },
                    attrs: { id: "imagenProducto", src: _vm.imagenProducto }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "fv lb",
                  staticStyle: {
                    width: "60%",
                    height: "100%",
                    "margin-left": "10px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showPrecioNormal,
                          expression: "showPrecioNormal"
                        }
                      ],
                      staticClass: "fv lt",
                      staticStyle: { width: "100%", height: "40px" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "10px",
                            "font-weight": "400",
                            "margin-top": "5px"
                          }
                        },
                        [_vm._v("Precio normal:")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "10px",
                            "font-weight": "400",
                            "text-decoration": "line-through"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.moneyLabel) +
                              _vm._s(_vm._f("formatMoney")(_vm.precioHabComp)) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "fv lt",
                      staticStyle: { width: "100%", height: "40px" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "fh lt",
                          staticStyle: { width: "100%", "margin-top": "0px" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "10px",
                                "font-weight": "500"
                              }
                            },
                            [_vm._v("Promoción:")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "10px",
                                "font-weight": "500",
                                color: "#aaaaaa",
                                "margin-left": "2px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.porcentajeDescuento))]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "10px",
                            "font-weight": "500"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.moneyLabel) +
                              _vm._s(
                                _vm._f("formatMoney")(_vm.precioPromoComp)
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77b08c3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77b08c3e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/home/itemPromocionHome.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-77b08c3e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/home/itemPromocionHome.vue
// module chunks = 0